<template>
  <div class="select-component">
    <el-dialog
      :visible.sync="dialogVisible"
      :title="isDetail ? '验收差异情况' : '差异处理'"
      custom-class="different-dialog"
      @close="handleClose"
    >
      <div class="body">
        <div class="info">
          <el-row>
            <el-col :span="7">
              货主货品编码：{{ rowData.shipperGoodsCode }}
            </el-col>
            <el-col :span="7">
              货品名称：{{ rowData.goodsName }}
            </el-col>
            <el-col :span="4">
              温层：{{ TEMPERATURE_LAYER[rowData.temperatureLayer] }}
            </el-col>
            <el-col :span="6">
              规格：{{ rowData.spec }}
            </el-col>
          </el-row>
        </div>
        <p v-if="isDetail" class="tips">
          提示：当前页面展示的是验收明细对应货品的差异情况，而非验收明细的差异情况
        </p>
        <div style="padding: 20px 20px">
          <div class="check-info">
            <h3 class="title">
              验收情况
            </h3>
            <div class="wrapper">
              <div class="booking-num">
                <div>
                  <span class="words">预约量</span>
                  {{ unitNumber.calculate({
                    smallUnitNumber: rowData.bookingNum,
                    ...rowData,
                  }).txt || 0 }}
                </div>
              </div>
              <div class="quote-wrapper">
                <div class="quote">
                  <div />
                </div>
              </div>
              <div class="cal-num">
                <div class="received">
                  <span class="words">已验收量</span>
                  {{ unitNumber.calculate({
                    smallUnitNumber: rowData.acceptanceNum,
                    ...rowData,
                  }).txt || 0 }}
                </div>
                <div class="rejection">
                  <span class="words">拒收量</span>
                  {{ unitNumber.calculate({
                    smallUnitNumber: rowData.rejectNum,
                    ...rowData,
                  }).txt || 0 }}
                </div>
                <div class="out-of-stock">
                  <span class="words">缺货量</span>
                  <span v-if="showLockNum">{{ unitNumber.calculate({
                    smallUnitNumber: rowData.lackNum,
                    ...rowData,
                  }).txt || 0 }}</span>
                  <span
                    v-else
                    class="input loack-tips"
                  >
                    提示：单据验收完成后，自动计算得出
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="promblem-goods-info">
            <h3 class="title">
              问题品情况
            </h3>
            <div class="wrapper">
              <div class="booking-num">
                <div class="problem-num">
                  <span class="words">问题品总数</span>
                  <span class="input">
                    <template v-if="rowData.bigUnit !== rowData.smallUnit">
                      {{ problemAllNum.bigNum }}
                      <span>{{ rowData.bigUnit }}</span>
                    </template>
                    {{ problemAllNum.smallNum }}
                    <span>{{ rowData.smallUnit }}</span>
                  </span>
                </div>
              </div>
              <div class="quote-wrapper">
                <div class="quote">
                  <div />
                </div>
              </div>
              <div class="cal-num problem-cal">
                <div class="received">
                  <span class="words">拒收量</span>
                  <span class="input">
                    <template v-if="rowData.bigUnit !== rowData.smallUnit">
                      <el-input-number
                        v-model="rejectionNum.bigNum"
                        :min="0"
                        :step="1"
                        :precision="0"
                        step-strictly
                        :controls="false"
                        :disabled="isDetail"
                        style="width: 60px"
                      />
                      <span style="margin: 0 10px">{{ rowData.bigUnit }}</span>
                    </template>
                    <el-input-number
                      v-model="rejectionNum.smallNum"
                      :min="0"
                      :step="0.001"
                      :precision="3"
                      step-strictly
                      :controls="false"
                      :disabled="isDetail"
                      style="width: 80px"
                      @change="handleRverseNum($event, 'rejectionNum')"
                    />
                    <span style="margin-left: 10px">{{ rowData.smallUnit }}</span>
                    <p
                      v-if="showRcords('rejectionNum')"
                      class="reject-reason"
                      @click="handleRecordProblem('rejectionNum')"
                    >
                      {{ `${isDetail ? '' : '记录'}拒收原因` }}
                    </p>
                  </span>
                </div>
                <div class="rejection">
                  <span class="words">问题品暂收量</span>
                  <span class="input">
                    <template v-if="rowData.bigUnit !== rowData.smallUnit">
                      <el-input-number
                        v-model="problemReceivedNum.bigNum"
                        :min="0"
                        :step="1"
                        :precision="0"
                        step-strictly
                        :controls="false"
                        :disabled="isDetail"
                        style="width: 60px"
                      />
                      <span style="margin: 0 10px">{{ rowData.bigUnit }}</span>
                    </template>
                    <el-input-number
                      v-model="problemReceivedNum.smallNum"
                      :min="0"
                      :step="0.001"
                      :precision="3"
                      step-strictly
                      :controls="false"
                      style="width: 80px"
                      :disabled="isDetail"
                      @change="handleRverseNum($event, 'problemReceivedNum')"
                    />
                    <span style="margin-left: 10px">{{ rowData.smallUnit }}</span>
                    <p
                      v-if="showRcords('problemReceivedNum')"
                      class="reject-reason"
                      @click="handleRecordProblem('problemReceivedNum')"
                    >
                      {{ `${isDetail ? '' : '记录'}暂收货品问题` }}
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div>
          <a-button @click="handleClose">
            {{ isDetail ? '关 闭' : '取 消' }}
          </a-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import unitNumber from '@/utils/unitNumber';
import BigNumber from 'bignumber.js';
import {
   getInWarehouseDiff, 
   getShipperInfoByCode 
  } from '../../api';
// 温层
const TEMPERATURE_LAYER = {
  NORMAL: '常温',
  COLD: '冷冻',
  REFRIGERATE: '冷藏',
  CONSTANT: '恒温',
};
export default {
  name: 'HandleDifferentDialog',
  emits: ['onSure', 'close'],
  data() {
    return {
      unitNumber,
      TEMPERATURE_LAYER,
      dialogVisible: false,
      rowData: {},
      rejectionNum: {
        smallNum: 0,
        bigNum: 0,
        problemReason: [],
      },
      problemReceivedNum: {
        smallNum: 0,
        bigNum: 0,
        problemReason: [],
      },
      loading: {
        submit: false,
      },
      keyName: 'rejectionNum',
      isDetail: false,
      showLockNum: false,
      qualityInspections: [],
    };
  },
  computed: {
    problemAllNum() {
      const rejectionTotal = this.getTotal(this.rejectionNum);
      const problemReceivedTotal = this.getTotal(this.problemReceivedNum);
      const problemTotal = new BigNumber(rejectionTotal).plus(problemReceivedTotal);
      const calcProblem = unitNumber.calculate({
        smallUnitNumber: problemTotal,
        conversionRate: this.rowData.conversionRate,
      });
      return {
        smallNum: calcProblem.smallUnitNumber,
        bigNum: calcProblem.bigUnitNumber,
      };
    },
  },
  methods: {
    async showDialog(rowData, isDetail = false, showLockNum) {
      this.dialogVisible = true;
      this.showLockNum = showLockNum;
      const receiptOrderDetailId = isDetail ? rowData.bizDetailId : rowData.receiptOrderDetailId;
      this.isDetail = isDetail;
      this.rowData = await getInWarehouseDiff({ receiptOrderDetailId });
      this.setDefaultData(this.rowData, 'rejectNum', 'rejectReasons', 'rejectionNum');
      this.setDefaultData(this.rowData, 'problemReceiveNum', 'problemReceiveReasons', 'problemReceivedNum');
      this.getProblemList(rowData);
    },
    // 提前把拒收原因列表数据请求回来
    async getProblemList({ shipperCode }) {
      const { records } = await getShipperInfoByCode({ shipperCode });
      const { qualityInspections } = records[0];
      // 卸货 货品 的质量选项
      this.qualityInspections = qualityInspections.filter((item) => item.stepType === 'UNLOAD'
        && item.dimensionalityType === 'GOODS');
    },
    setDefaultData(rowData, dataNumName, dataReasonName, setKeyName) {
      const { smallUnitNumber, bigUnitNumber } = unitNumber.calculate({
        smallUnitNumber: rowData[dataNumName],
        conversionRate: rowData.conversionRate,
      });
      this[setKeyName] = {
        smallNum: smallUnitNumber,
        bigNum: bigUnitNumber,
      };
      this[setKeyName].problemReason = rowData[dataReasonName];
    },
    showRcords(keyName) {
      const hasTotal = !!this.getTotal(this[keyName]);
      if (!hasTotal) {
        this[keyName].problemReason = [];
      }
      return hasTotal;
    },
    getTotal({ smallNum, bigNum }) {
      const totalNum = unitNumber.getTotal({
        smallUnitNumber: smallNum,
        bigUnitNumber: bigNum,
        conversionRate: this.rowData.conversionRate,
      });
      return totalNum;
    },
    async handleRverseNum(value, keyName) {
      const { smallUnitNumber, bigUnitNumber } = unitNumber.calculate({
        smallUnitNumber: value,
        bigUnitNumber: this[keyName].bigNum,
        conversionRate: this.rowData.conversionRate,
      });
      await this.$nextTick();
      this[keyName].smallNum = smallUnitNumber;
      this[keyName].bigNum = bigUnitNumber;
    },
    handleRecordProblem(keyName) {
      this.keyName = keyName;
      let title = keyName === 'rejectionNum' ? '拒收原因' : '暂收货品问题';
      title = this.isDetail ? title : `记录${title}`;
      this.$refs.problemGoodsDialog.showDialog(title,
        this.qualityInspections, this[keyName].problemReason, this.isDetail);
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
  },
};
</script>
<style scoped lang="less">
.info {
  padding: 16px;
  background-color: #E6F7FF;
  border: solid 1px #91D5FF;
  border-radius: 4px;
}
.tips {
  margin-top: 10px;
  color: #faad14;
}
.check-info {
  border-bottom: solid 1px #ccc;
  padding-bottom: 20px;
}
.promblem-goods-info {
  margin-top: 20px;
  padding-bottom: 20px;
}
.title {
  font-size: 18px;
}
.wrapper {
  display: flex;
  margin-top: 20px;
  .booking-num {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 10px;
    .problem-num {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
    }
    .words {
      margin-right: 10px;
      font-size: 16px;
      font-weight: bold;
      white-space: nowrap;
    }
    .input {
      display: flex;
      align-items: center;
    }
  }
  .quote-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .quote {
    position: relative;
    width: 40px;
    height: 140px;
    margin-right: 10px;
  }
  .quote::before, .quote::after, .quote ::before, .quote ::after {
    content: '';
    display: block;
    position: absolute;
    width: 20px;
    height: calc(50% - 20px);
    border-style: solid;
    border-color: #000;
    border-width: 0;
  }
  .quote ::before, .quote ::after {
    left: 18px;
    border-left-width: 2px;
    border-color: #EE8938;
  }
  .quote::before, .quote::after {
    left: 0;
    border-right-width: 2px;
    border-color: #EE8938;
  }
  .quote ::before {
    top: 0;
    border-top-left-radius: 20px;
  }
  .quote ::after {
    bottom: 0;
    border-bottom-left-radius: 20px;
  }
  .quote::before {
    top: 20px;
    border-bottom-right-radius: 20px;
  }
  .quote::after {
    bottom: 20px;
    border-top-right-radius: 20px;
  }
  .cal-num {
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .words {
      margin-right: 10px;
      font-size: 16px;
      font-weight: bold;
      white-space: nowrap;
    }
    .out-of-stock, .rejection, .received, .input {
      display: flex;
      align-items: center;
    }
  }
  .problem-cal {
    height: 170px;
  }
  .reject-reason {
    margin-left: 10px;
    color: #1890FF;
    cursor: pointer;
  }
  .loack-tips {
    color: #1890FF;
  }
}
</style>
